import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

export default class VendorsPage extends React.Component<any, null> {
	render() {
		return (
			<div>
				<Route
					path="/supplier/vendors"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/supplier/vendors/overview',
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}
